import { IconFont } from '@/components/IconFont'
import OrbitAvatar from '@/components/OrbitAvatar'
import { getGroupMembers, getOrganizationMemberGroup } from '@/services/member/member'
import { ACCOUNT_TYPES } from '@/utils/constants'
import { useRequest } from 'ahooks'
import { Button, Input, List, Row, Space, Typography } from 'antd'
import { memo, useContext, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import { OrganizationContext } from '../../..'
import { default as AddMembersModal } from './AddMembers'
import EditGroupName from './EditGroupName'

export default memo(function OrganizationGroupItem() {
  const { id } = useParams()
  const orgData = useContext(OrganizationContext).orgData!
  const { data: groupMembers = [], refresh: refreshMembers } = useRequest(() => getGroupMembers(orgData.id, Number(id)))
  const { data: currentGroup, refresh: refreshGroup } = useRequest(() =>
    getOrganizationMemberGroup(orgData.id, Number(id))
  )
  const [isEdit, setIsEdit] = useState(false)
  const [filterValue, setFilterValue] = useState('')

  const addMembers = () => {
    AddMembersModal.show({
      title: 'Edit Members',
      orgId: orgData.id,
      currentGroup: currentGroup!,
      onSuccess: () => {
        refreshMembers()
      }
    })
  }

  if (!currentGroup) {
    return null
  }

  return (
    <Space className={'w100'} direction='vertical'>
      <Row justify={'space-between'} align={'middle'}>
        {!!isEdit ? (
          <EditGroupName
            currentGroup={currentGroup}
            orgId={orgData.id}
            onCancel={() => {
              setIsEdit(false)
            }}
            onSuccess={() => {
              refreshGroup()
            }}
          />
        ) : (
          <Space align={'center'}>
            <Typography.Title level={4} className={'mb-0'}>
              {currentGroup.name}
            </Typography.Title>
            <IconFont type={'icon-edit'} onClick={() => setIsEdit(true)} />
          </Space>
        )}

        <Link to={'../'}>
          <Button>
            <IconFont type='icon-fanhui' />
          </Button>
        </Link>
      </Row>

      <Row justify={'space-between'} align={'middle'}>
        <Input
          value={filterValue}
          style={{ width: '250px' }}
          placeholder='Find a member'
          prefix={<IconFont type={'icon-search'} />}
          onChange={(event) => {
            const value = event.target.value
            setFilterValue(value)
          }}
        />

        <Button type={'primary'} icon={<IconFont type='icon-add' />} onClick={addMembers}>
          Edit members
        </Button>
      </Row>

      <List
        header={`${groupMembers.length} members in ${currentGroup.name}`}
        bordered
        itemLayout='horizontal'
        dataSource={groupMembers}
        locale={{
          emptyText: (
            <Space direction={'vertical'} className={'p-4'}>
              <Button onClick={addMembers}>
                <IconFont type='icon-add' />
              </Button>
              <span>Add a member to {currentGroup.name}</span>
            </Space>
          )
        }}
        renderItem={(item) => (
          <List.Item key={item.id}>
            <List.Item.Meta
              avatar={<OrbitAvatar avatar={item.avatar} name={item.fullName} />}
              title={item.fullName}
              description={item.email}
            />
            <div>{ACCOUNT_TYPES[item.accountType]}</div>
          </List.Item>
        )}
      />
    </Space>
  )
})
